import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../common/components/form/form.module'

export default function ContactsBasicInfoComponent({ tags,id,tagNames,handleInnerFormChange, accounts, salutation, contactSource, selectedContact }: any) {

    return (
        <>
            <AccordionContainer
                child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                            label="Account"
                            labelField="Name"
                            list={accounts}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'AccountId'
                                );
                            }}
                            optionName='Choose Account'
                            type="select"
                            value={selectedContact?.AccountId}
                            valueField="AccountId"
                        />
                        <InputContainer
                            label="Phone"
                            name="Phone"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Phone'
                                )
                            }}
                            type="number"
                            value={selectedContact?.Phone}
                        />
                        <InputContainer
                            label="Email"
                            name="Email"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Email'
                                )
                            }}
                            type="text"
                            value={selectedContact?.Email}
                        />
                        <InputContainer
                            label="FirstName"
                            name="FirstName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'FirstName'
                                )
                            }}
                            type="text"
                            value={selectedContact?.FirstName}
                        />

                        <InputContainer
                            label="LastName"
                            name="LastName"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'LastName'
                                )
                            }}
                            type="text"
                            value={selectedContact?.LastName}
                        />
                        <InputContainer
                            label="Salutation"
                            labelField="Text"
                            list={salutation}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'SalutationId'
                                );
                            }}
                            optionName='Choose Persion Title'
                            type="select"
                            value={selectedContact?.SalutationId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Title"
                            name="Title"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                )
                            }}
                            type="text"
                            value={selectedContact?.Title}
                        />
                        <InputContainer
                            label="Contact Source"
                            labelField="Text"
                            list={contactSource}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ContactSourceId'
                                );
                            }}
                            optionName='Choose Contact Source'
                            type="select"
                            value={selectedContact?.ContactSourceId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Photo URL"
                            name="PhotoUrl"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PhotoUrl'
                                )
                            }}
                            type="text"
                            value={selectedContact?.PhotoUrl}
                        />
                    </div>
                }
                expandedPanel="basicInfo"
                headerTitle="Basic Info"
            />
           { id > 0 && (
  <AccordionContainer
    child={
      <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer
          label="Tag"
          labelField="displayText"
          list={tags?.length > 0 ? tags : tagNames}
          onValueChange={(event: any, newValue: any) => {
            handleInnerFormChange(
              event.target.value,
              'TagEntityMappingsValueIds',
            );
          }}
          optionName="Choose Contact Tag"
          type="select"
          value={selectedContact?.TagEntityMappingsValueIds}
          valueField="Id"
        />
      </div>
    }
    expandedPanel="Contact Tag"
    headerTitle="Contact Tag"
  />
)}
        </>
    )
}